export const API_URL = "https://api.xt96s.com"
export const WS_URL = "wss://ws.xt96s.com"
export const WEB_URL = "https://qechat2.com"
export const CDN_URL = "https://static.h78sp.com"
/** 极光控制台 iOS 应用的 AppKey */
export const JPUSH_APP_KEY_IOS = "9d8d2bac7176e9c2bd78f332"
/** 极光控制台 Android 应用的 AppKey */
export const JPUSH_APP_KEY_ANDROID = "578d59cd411e829e055a305b"
export const APP_NAME = "企鹅";
export const REDIRECT_URL = "https://xt96s.com/redirect.html"
export const ENCRYPT_KEY = "4JWRTfJGFPr6rNEqNHSz1ZVJi6YVOyfs-I_QqtFBYQc="